var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7127 10.9363C76.5358 9.75744 74.6263 9.75541 73.4494 10.9313L37.2786 47.0067L24.2283 32.8328C23.1006 31.6087 21.1941 31.5293 19.968 32.6568C18.7428 33.7845 18.6644 35.692 19.792 36.9171L34.968 53.3985C35.5238 54.0026 36.3016 54.3534 37.1217 54.3704C37.1437 54.3713 37.165 54.3713 37.1861 54.3713C37.9831 54.3713 38.7498 54.0548 39.3147 53.492L77.7067 15.2006C78.8866 14.0248 78.8886 12.1153 77.7127 10.9363Z",
    fill: "#2F8710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9848 36.9848C75.3195 36.9848 73.9698 38.3345 73.9698 40C73.9698 58.7317 58.7317 73.9698 40 73.9698C21.2694 73.9698 6.03016 58.7317 6.03016 40C6.03016 21.2694 21.2694 6.03016 40 6.03016C41.6653 6.03016 43.0152 4.68047 43.0152 3.01516C43.0152 1.34969 41.6653 0 40 0C17.9437 0 0 17.9437 0 40C0 62.0553 17.9437 80 40 80C62.0553 80 80 62.0553 80 40C80 38.3347 78.6503 36.9848 76.9848 36.9848Z",
    fill: "#2F8710"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderompleted);
export default __webpack_public_path__ + "static/media/orderСompleted.ec6f09b344ff2289776035ac695d9b04.svg";
export { ForwardRef as ReactComponent };